import { Component } from '@angular/core';
import { membersuiteCreditEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Credits') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitecredit-form',
    templateUrl: './membersuitecredit.form.component.html'
})
export class membersuiteCreditFormComponent extends BaseFormComponent {
    public record!: membersuiteCreditEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

